import React from 'react'
import { DataItemRow, LocationMap, NothingMessage, Texto, useThemeContext } from '@gravitate-js/excalibrr'
import { Col, Form, Row, Select } from 'antd'
import { darkMapTheme } from '@components/_SiteWide/Theming/darkMapTheme'

const { Option } = Select

export const Depot = ({ driver, locations, editing }) => {
  const filteredDepots = locations && locations.sort((a, b) => (a.name > b.name ? 1 : -1))

  const { isDarkTheme } = useThemeContext()
  let mapCenter = {}
  let popOverContent = null
  const driverLocation =
    locations && driver && driver.depot
      ? locations.filter((l) => l.name.toLowerCase() === driver.depot.toLowerCase())[0]
      : null

  if (driverLocation) {
    mapCenter = { lat: driverLocation.lat, lng: driverLocation.lon }
    popOverContent = (
      <div>
        <DataItemRow label='Address' extraClass='pt-2'>
          {driverLocation.address}
        </DataItemRow>
        <DataItemRow label='Market' extraClass='pt-2'>
          {driverLocation.market}
        </DataItemRow>
        <DataItemRow label='Type' extraClass='pt-2'>
          {driverLocation.type}
        </DataItemRow>
        <DataItemRow label='Hours' extraClass='pt-2'>
          {driverLocation.hours}
        </DataItemRow>
        <DataItemRow label='Contact' extraClass='pt-2'>
          {driverLocation.contact}
        </DataItemRow>
        <DataItemRow label='Phone' extraClass='pt-2'>
          {driverLocation.contact_phone}
        </DataItemRow>
        <DataItemRow label='Active' extraClass='pt-2'>
          {driverLocation.active ? 'Yes' : 'No'}
        </DataItemRow>
      </div>
    )
  }

  const options = filteredDepots.map((depot) => ({ value: depot.name }))

  return (
    <Col span={25}>
      <Texto category='h5'>{`Depot`}</Texto>
      <Row className='pt-4'>
        <Col className={`depot-name mb-3 ${editing ? 'edit' : ''}`} span={24} align='right'>
          {editing ? (
            <Form.Item name='depot' rules={[{ required: true, message: 'Depot is required' }]}>
              <Select
                showSearch
                style={{ width: '100%' }}
                placeholder='Search Depots'
                allowClear
                defaultValue={driver?.depot}
              >
                {options.map((option, i) => (
                  <Option value={option.value} key={i}>
                    {option.value}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          ) : (
            <div>{driver?.depot}</div>
          )}
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {driverLocation && (
            <div className='depot-map'>
              <LocationMap
                mapCenter={mapCenter}
                location={driverLocation}
                popOverContent={popOverContent}
                extraOptions={isDarkTheme && darkMapTheme}
              />
            </div>
          )}
        </Col>
      </Row>
    </Col>
  )
}
